import Link from "next/link";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { isTargetTicket } from "../../../lib/ticket";
import { PER_PAGE } from "../../../repositories/ticketRepo";
import { notClosedTicketsState } from "../../../state/selectors/ticketSelectors";
import CustomTicketList from "./CustomTicketList";
import Pagination from "./Pagination";

const CustomView = ({ built }) => {

  const notClosedTickets = useRecoilValue(notClosedTicketsState);
  const [filtered, setFiltered] = useState([]);
  const [offsetStart, setOffsetStart] = useState(0);
  const [currentTickets, setCurrentTickets] = useState([])
  const [pageCount, setPageCount] = useState(Math.ceil((notClosedTickets?.length || 0) / PER_PAGE));

  const pageChange = (event) => {
    const newOffsetStart = (event.selected * PER_PAGE) % (notClosedTickets?.length || 1);
    setOffsetStart(newOffsetStart);
  }

  useEffect(() => {
    if (!notClosedTickets?.length || !built) return
    const filtered = notClosedTickets.filter((ticket) => {
      return isTargetTicket(built, ticket)
    })
    setFiltered(filtered)
  }, [notClosedTickets, built]);

  useEffect(() => {
    const offsetEnd = offsetStart + PER_PAGE;

    setCurrentTickets(filtered?.slice(offsetStart, offsetEnd));
  }, [filtered, offsetStart])

  return (<>
    <div className="flex justify-between">
      <h2 className="text-5xl mb-14 mt-20">{built?.name || "名前が設定されていません"}</h2>
      <p className="mt-20">
        <Link
          href={`/tickets/new`}
          className={`bg-green-500 hover:bg-green-700 text-white text-2xl font-bold py-3 px-7 rounded focus:outline-none`}
        >
          新規
        </Link>
      </p>
    </div>
    <div className="drop-shadow">
      <CustomTicketList
        currentTickets={currentTickets}
        unit={built}
      />
      <Pagination
        offsetStart={offsetStart}
        currentLength={currentTickets?.length}
        maxLength={filtered?.length}
        pageCount={pageCount}
        pageChange={pageChange}
      />
    </div>
  </>)
}

export default CustomView;